import React, { useContext, useEffect, useState } from 'react';
import download from 'downloadjs';
import { useDownloadBackgroundDocument } from '~/hooks/useDocuments/useDocuments';
import { DownloadContext } from '~/contexts/DownloadContext/DownloadContext';

export const DownloadControl: React.VFC = () => {
  const { isActive, docUUID, apply } = useContext(DownloadContext);
  const { data, isLoading, refetch, isPreviousData } =
    useDownloadBackgroundDocument(isActive, docUUID);

  useEffect(() => {
    if (
      !!data &&
      !!data.data &&
      data.data.size > 0 &&
      !isPreviousData &&
      isActive
    ) {
      download(
        new Blob([data.data], { type: data.data.type }),
        data.headers['content-disposition'].match(/filename="(.+)"/)[1],
      );
      apply(false, '');
    }
  }, [data]);

  if (!data) {
    return null;
  }

  return null;
};
